module.exports = __webpack_public_path__ + "static/media/10.01f56948.mp3";